import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AutoSaveStatus, WikiCardPageMode } from '../../models/wiki-card-model';
import { Wiki } from '@local/client-contracts';
import { HubService } from 'src/app/bar/services/hub.service';

@UntilDestroy()
@Component({
  selector: 'wiki-card-draft-sub-header',
  templateUrl: './wiki-card-draft-sub-header.component.html',
  styleUrls: ['./wiki-card-draft-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiCardDraftSubHeaderComponent {
  private _draft: Wiki.Draft;
  private _autoSaveStatus: AutoSaveStatus;

  textStatus: string;
  iconStatus: string;
  modifiedTimeTooltip: string;

  @Input() set draft(val: Wiki.Draft) {
    this._draft = val;
    this.initStatus();
  }
  @Input() pageMode: WikiCardPageMode;
  @Input() set autoSaveStatus(val: AutoSaveStatus) {
    this._autoSaveStatus = val;
    this.initStatus();
  }

  @HostBinding('attr.pageMode')
  get pageModeAttr() {
    return this.pageMode;
  }

  get draft() {
    return this._draft;
  }

  get autoSaveStatus() {
    return this._autoSaveStatus;
  }

  constructor(private cdr: ChangeDetectorRef, private hubService: HubService) {}

  initStatus() {
    this.modifiedTimeTooltip = null;
    switch (this.autoSaveStatus) {
      case 'saved':
        this.textStatus = 'Saved';
        this.iconStatus = 'icon-check-circle';
        break;
      case 'saving':
        this.textStatus = 'Saving';
        this.iconStatus = 'icon-sync';
        break;
      default:
        this.buildTimeParse();
        break;
    }
    this.cdr.markForCheck();
  }

  async buildTimeParse() {
    if (!this.draft) {
      return;
    }
    const timePhrase = await this.hubService.getTimePhrases(this.draft);
    this.textStatus = `Edited ${timePhrase.timeText} by ${timePhrase.name}`;
    this.modifiedTimeTooltip = timePhrase.fullDetailsTime;
    this.iconStatus = 'icon-clock';
    this.cdr.markForCheck();
  }
}
